import {Injectable} from '@angular/core';
import {UcetniJednotkaDataService} from '../ucetni-jednotka-data/ucetni-jednotka-data.service';
import {DetailService, Field, FormSettings} from '../shared/detail/detail.service';
import {ButtonInvoke} from '../shared/panel-buttons/panel-buttons.component';
import {Router} from '@angular/router';
import {ApiAttributeParams, MapperKeys} from "../shared/crud/abstractions/base-crud";
import {DefiniceVykazuDto} from "../definice-vykazu-data/models/DefiniceVykazuDto";
import {UcetniObdobiDto} from "../ucetni-obdobi-data/models/UcetniObdobiDtos";
import {UctovyRozvrhDataService} from "../uctovy-rozvrh-data/uctovy-rozvrh-data.service";
import {DokladovaRadaDataService} from "../dokladova-rada-data/dokladova-rada-data.service";
import {ExportUcetniJednotkaDto} from "../ucetni-jednotka-data/models/ExportUcetniJednotkaDto";
import {UcetniJednotkaDetailFormDialogService} from "./ucetni-jednotka-detail-form-dialog-service";
import {TableDialogComponent} from "../shared/cml-forms/show-table.dialog/table-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {UcetniObdobiDataService} from "../ucetni-obdobi-data/ucetni-obdobi-data.service";

export class UcetniJednotkaFormSettings implements FormSettings {
  fieldsNew: Field[] = [
    { name: 'nazev', title: 'Název', type: 'string', maxLength: 255, required:true },
    { name: 'nazevS', title: 'Název krátký', type: 'string', maxLength: 20},
    { name: 'refOrganizace', title: 'refOrganizace', type: 'string', maxLength: 150},
    { name: 'ico', title: 'IČO', type: 'string', required: true, minLength: 8, maxLength: 10, pattern: '^[0-9]*$' },
    { name: 'dic', title: 'DIČ', type: 'string', maxLength: 30},
    { name: 'kodPravniFormy', title: 'Kód právní formy', type: 'dropdown', required: true, maxLength: 3 },
    { name: 'pouzeDenik', title: 'Pouze deník', type: 'boolean', required: true },
    { name: 'kod', title: 'Kód', type: 'string', required: true, minLength: 2, maxLength: 10 }
  ];
  fieldsEdit: Field[] = [
    { name: 'nazev', title: 'Název', type: 'string', required: true, maxLength: 255 },
    { name: 'nazevS', title: 'Název krátký', type: 'string', maxLength: 20},
    { name: 'refOrganizace', title: 'refOrganizace', type: 'string', maxLength: 150},
    { name: 'ico', title: 'IČO', type: 'string', required: true, minLength: 8, maxLength: 10, pattern: '^[0-9]*$' },
    { name: 'dic', title: 'DIČ', type: 'string', maxLength: 30},
    { name: 'kodPravniFormy', title: 'Kód právní formy', type: 'dropdown', required: true, maxLength: 3 },
    { name: 'pouzeDenik', title: 'Pouze deník', type: 'boolean',required: true }
  ];
}
const EXPORT_COLUMNS: Field[] = [
  { name: "exportUo", type: "boolean", title: "Exportovat účetní období", required: true, default: true},
  { name: "exportDokladoveRady", type: "boolean", title: "Exportovat dokladovou řadu", required: true, default: true},
  { name: "exportUctovehoRozvrhu", type: "boolean", title: "Exportovat účtový rozvrh",required: true, default: true}
];
@Injectable()
export class UcetniJednotkaDetailService extends DetailService {
  definiceUcetniJednotky: DefiniceVykazuDto[] = []
  ucetniObdobiJednotky: UcetniObdobiDto[] = []
  ucetniObdobiTableColumns: Field[] =  []
  editColumns = EXPORT_COLUMNS

  override createToolbarButtons(): ButtonInvoke[] {
    let buttons = super.createToolbarButtons();
    if (this.component && !this.component.isNew) {
      buttons.splice(buttons.length - 1, 0, new ButtonInvoke(this, 'Nastavení účetní jednotky', 'navigateToNastaveni', '<i class="cml-fw cml-lg cml-arrow-right"></i>', 'cml-active-black'));
      buttons.splice(buttons.length - 1,0,new ButtonInvoke(this, 'Exportovat UJ', 'downloadUJ', '<i class="cml-fw cml-lg cml-move-transfer-file"></i>', 'cml-active-purple'))
    }
    return buttons;
  }

  override async delete(id: string, from?: ApiAttributeParams): Promise<void> {
    const promises = this.ucetniObdobiJednotky.map( async (obdobi) => {
      const mapper = this.ucetniObdobiDataService.setMapper([
        {key: MapperKeys.KodUj,value: obdobi.kodUj},
        {key: MapperKeys.KodUo, value: obdobi.kod}
      ])
      await this.ucetniObdobiDataService.delete(mapper)
    })
    await Promise.all(promises)
    await super.delete(id, from);
  }

  navigateToNastaveni() {
    this.router.navigateByUrl(this.router.url + '/nastaveni-ucetni-jednotky');
  }

  navigateToUctovyRozvrh() {
    this.router.navigateByUrl(this.router.url + '/uctovy-rozvrh')
  }

  constructor(
    private ucetniObdobiDataService: UcetniObdobiDataService,
    protected ucetniJednotkaDataService: UcetniJednotkaDataService,
    protected dokladovaRadaDataService: DokladovaRadaDataService,
    protected uctovyRozvrhDataService: UctovyRozvrhDataService,
    protected router: Router,
    protected matDialog: MatDialog) {
    super(ucetniJednotkaDataService, new UcetniJednotkaFormSettings());
  }

  getPrefilledColumns(baseColumns: Field[] = [], userResponse: any = undefined) {
    let copyColumns: Field[] = [];
    baseColumns.forEach(x => {
      copyColumns.push(Object.assign({}, x))
    });
    copyColumns.forEach(x => x.default = userResponse[x.name] ?? x.default)
    return copyColumns;
  }

  async downloadUJ() {
    const detail = this.getPrefilledColumns(this.editColumns, this.component?.entity);

    const userRes = await this.ucetniJednotkaDataService.dialogService.form(
      {
        title: "Export UJ",
        detail,
      },
      UcetniJednotkaDetailFormDialogService,
    );
    if (!userRes) return;

    const jsonForParse: ExportUcetniJednotkaDto = {
      ucetniJednotka: this.component?.entity,
    };

    if (userRes.value.exportUo) {
      if (this.ucetniObdobiJednotky.length !== 1) {
        const selectedUcetniObdobi = await this.openUcetniObdobiDialog();
        if(selectedUcetniObdobi.length <= 0)
          return
        jsonForParse.ucetniObdobi = selectedUcetniObdobi;
      } else {
        jsonForParse.ucetniObdobi = this.ucetniObdobiJednotky;
      }
    }

    await this.processDownload(jsonForParse, userRes.value);
  }

  private openUcetniObdobiDialog(): Promise<UcetniObdobiDto[]> {
    return new Promise((resolve) => {
      const dialogRef = this.matDialog.open(TableDialogComponent, {
        data: {
          title: `Vyberte účetní období, která chcete exportovat z účetní jednotky`,
          filter: false,
          dataSource: this.ucetniObdobiJednotky,
          columns: this.ucetniObdobiTableColumns,
          selectable: true,
          displayedColumns: ['select', 'kod', 'od', 'do'],
        },
        panelClass: 'dialog-panel',
      });

      dialogRef.afterClosed().subscribe((result: UcetniObdobiDto[]) => {
        resolve(result || []);
      });
    });
  }
  async processDownload(jsonForParse: ExportUcetniJednotkaDto, exportValues: any) {
    const { exportDokladoveRady, exportUctovehoRozvrhu } = exportValues;

    if (exportDokladoveRady) {
      await this.dokladovaRada4Download(jsonForParse);
    }
    if (exportUctovehoRozvrhu) {
      await this.uctovyRozvrh4Download(jsonForParse);
    }

    await this.downloadParsedFile(jsonForParse);
  }

  async downloadParsedFile(jsonForParse: ExportUcetniJednotkaDto) {
    const jsonString = JSON.stringify(jsonForParse, null, 2);
    const blob = new Blob([jsonString], {type: 'application/json'});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const date = new Date();
    a.download = `${jsonForParse.ucetniJednotka.kod} ${date.getDate()}_${date.getMonth()}_${date.getFullYear()} ${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  async uctovyRozvrh4Download(jsonForParse: ExportUcetniJednotkaDto) {
    if (!jsonForParse.ucetniObdobi) {
      return;
    }
    const promises = jsonForParse.ucetniObdobi.map(async (obdobi) => {
      const mapper = this.uctovyRozvrhDataService.setMapper([
        { key: MapperKeys.KodUj, value: jsonForParse.ucetniJednotka.kod },
        { key: MapperKeys.KodUo, value: obdobi.kod },
      ]);
      obdobi.uctovyRozvrh = await this.uctovyRozvrhDataService.getAll({ params: mapper });
    });
    await Promise.all(promises);
  }

  async dokladovaRada4Download(jsonForParse: ExportUcetniJednotkaDto) {
    if (jsonForParse.ucetniObdobi) {
      const promises = jsonForParse.ucetniObdobi.map(async (obdobi) => {
        const mapper = this.dokladovaRadaDataService.setMapper([
          {key: MapperKeys.KodUj, value: jsonForParse.ucetniJednotka.kod},
          {key: MapperKeys.KodUo, value: obdobi.kod},
        ]);

        const allDokladoveRadyObdobi = await this.dokladovaRadaDataService.getAll(mapper);

        obdobi.dokladovaRada = allDokladoveRadyObdobi.filter(rada => rada.kodUo === obdobi.kod);
      });
      await Promise.all(promises);
    }
  }
}
